export type ApiErrorBody = {
  error?: string;
  code?: string;
};

export function formatApiError(
  body: ApiErrorBody | null | undefined,
  fallback: string,
  status?: number,
) {
  const message = body?.error?.trim() || fallback;
  const code = body?.code?.trim();
  const statusSuffix = status ? ` [HTTP ${status}]` : "";
  return code ? `${message} (${code})${statusSuffix}` : `${message}${statusSuffix}`;
}

export async function readApiError(response: Response, fallback: string) {
  let body: ApiErrorBody | null = null;
  try {
    body = (await response.json()) as ApiErrorBody;
  } catch {
    // response may not be JSON
  }
  return formatApiError(body, fallback, response.status);
}

export async function readApiErrorBody(response: Response, fallback: string) {
  let body: ApiErrorBody | null = null;
  try {
    body = (await response.json()) as ApiErrorBody;
  } catch {
    // response may not be JSON
  }
  return {
    message: formatApiError(body, fallback, response.status),
    body,
  };
}
